import { Injectable } from '@angular/core';
import { DatasourceColumnUIModel } from '../models';
import { TableColumnsStore } from './table-columns.store';

@Injectable({ providedIn: 'root' })
export class TableColumnsService {
  constructor(private readonly tableColumnsStore: TableColumnsStore) {}

  public setColumns(columns: DatasourceColumnUIModel[]) {
    this.tableColumnsStore.setLoading(true);
    this.tableColumnsStore.remove();
    this.tableColumnsStore.upsertMany(columns);
    this.tableColumnsStore.setLoading(false);
  }
}
